import { CSSProperties, memo, ReactElement } from 'react';
import { TPopover } from 'interfaces/betslip';
import { OddButton } from './OddButton';
import { OddPopover } from './OddPopover';
import { ConfirmationPopover } from 'components/Shared/ConfirmationPopover/ConfirmationPopover';
import { useOddButtonPosition } from 'newhooks/sportsbook/useOddButtonPosition';

export type TOddProps = {
  parent: {
    value: string[];
    onChange: Function;
    marketColCount: number;
    whiteText?: boolean;
    showHandicaps?: boolean;
    hideHandicapName?: boolean;
    popover?: TPopover;
    hidePopover: () => void;
  };
  value: string;
  coeficient: number;
  oddFormat: number;
  handicap?: string;
  name?: string;
  base?: string | number;
  marketType?: string;
  type1?: string;
  gameId: number | string;
  size: 'default' | 'large';
  style?: CSSProperties;
  noBoosted?: boolean;
  fullName?: boolean;
  isBlocked?: number;
  isLive?: boolean;
  oddTextColor?: string;
  isUsaSinglePage?: boolean;
};

export const Odd = memo(
  ({
    parent,
    value,
    coeficient,
    oddFormat,
    name,
    base,
    marketType,
    type1,
    handicap,
    fullName,
    gameId,
    noBoosted,
    size,
    style,
    isBlocked,
    isLive,
    oddTextColor,
    isUsaSinglePage
  }: TOddProps): ReactElement => {
    const visible = Boolean(parent.popover?.id && parent.popover?.id === value);

    const { buttonRef, getButtonPosition } = useOddButtonPosition();

    if (parent?.popover?.validateRecaptcha && visible) {
      return (
        <>
          <ConfirmationPopover {...(parent.popover || {})} />
          <OddButton
            oddFormat={oddFormat}
            gameId={gameId}
            coeficient={coeficient}
            value={value}
            size={size}
            parent={parent}
            visible={visible}
            style={style}
            noBoosted={noBoosted}
            ref={buttonRef}
            name={name}
            base={base}
            fullName={fullName}
            handicap={handicap}
            isBlocked={isBlocked}
            type1={type1}
            marketType={marketType}
            isLive={isLive}
            oddTextColor={oddTextColor}
          />
        </>
      );
    }

    return (
      <OddPopover
        popover={parent.popover}
        visible={visible}
        hidePopover={parent.hidePopover}
        getButtonPosition={getButtonPosition}
      >
        <OddButton
          oddFormat={oddFormat}
          gameId={gameId}
          coeficient={coeficient}
          value={value}
          size={size}
          parent={parent}
          visible={visible}
          style={style}
          noBoosted={noBoosted}
          ref={buttonRef}
          name={name}
          base={base}
          fullName={fullName}
          handicap={handicap}
          isBlocked={isBlocked}
          type1={type1}
          marketType={marketType}
          oddTextColor={oddTextColor}
          isUsaSinglePage={isUsaSinglePage}
        />
      </OddPopover>
    );
  }
);
